import { number, shape, string } from 'prop-types';

export default shape({
    code: string,
    id: number.isRequired,
    label: string.isRequired,
    type: string,
});
